// Generación de audio Speech-to-Speech: manda el audio del usuario + la voz
// elegida al flujo de audio (rama dialogo_input_mode:"audio") vía el helper
// compartido (atlas /v1/audio/generate o n8n según flag, ADR-583) y registra
// el resultado como asset de audio del proyecto.
import { generateAudioCreator } from "./audioGenerate";
import { registerExistingAsset } from "../utils/projectAssets";

export interface GenerateS2SParams {
  projectId: string;
  companyId: string;
  userId: string;
  voiceId: string;
  audioUrl: string;
  audioDurationSec: number;
}

export async function generateS2SAudio(
  params: GenerateS2SParams,
): Promise<void> {
  const { path } = await generateAudioCreator({
    user_id: params.userId,
    ref_mode: "voz",
    voz_id: params.voiceId,
    project_id: params.projectId,
    // Trackeo (ADR-585): S2S alimenta un proyecto del Estudio (se graba
    // desde GenerarAudio pero el asset es del Estudio).
    modo_utilizado: "estudio_audio",
    velocidad_voz: 1.0,
    dialogo_input_mode: "audio",
    audio_url: params.audioUrl,
    audio_duration_sec: params.audioDurationSec,
  });
  // Registrar el audio generado (el backend ya lo escribió en storage) como
  // asset del proyecto, para que el plugin lo pueda listar e importar.
  await registerExistingAsset({
    projectId: params.projectId,
    companyId: params.companyId,
    userId: params.userId,
    storagePath: path,
    type: "audio",
    name: "Voz IA (grabada)",
    durationSeconds: params.audioDurationSec,
  });
}
